<template>
  <div class="center-content"><slot /></div>
</template>

<script>
export default {
  name: "centered-box"
}
</script>

<style lang="scss">
.center-content {
  padding: 3rem 1.5rem;
  max-width: 30rem;
  margin: 0 auto;
}
</style>
